import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import EventApi from "../services/event";
import { formatDateToTimeZoneUTC } from "../utils/Functions";

function usePersonData() {
    const [people, setPeople] = useState([]);
    const [person, setPerson] = useState({});
    const [status, setStatus] = useState([]);

    const fetchPersonById = async (id) => {
        try {
            const response = await EventApi.getPersonById(id);
            if (response?.data?.data) {
                const fetchedPerson = response.data.data;
                setPerson(fetchedPerson);
                return fetchedPerson;
            } else throw new Error("An error ocurred");
        } catch (error) {
            console.error("Error fetching person:", error);
            // toast.error("Erro ao buscar convidado");
            return false;
        }
    };

    const registerAccess = async (data) => {
        try {
            const response = await EventApi.registerAccess(data);
            if (response?.data?.data) {
                const fetchedPerson = response.data.data.personData;
                return fetchedPerson;
            } else throw new Error("An error ocurred");
        } catch (error) {
            console.error("Error fetching person:", error);
            // toast.error("Erro ao buscar convidado");
            return false;
        }
    };

    const registerAtActivity = async (activityId, data) => {
        if (!activityId) {
            toast.error("Erro ao identificar atividade");
            return false;
        }

        try {
            const response = await EventApi.addPersonToActivity(data);
            if (response?.data?.data) {
                const fetchedPerson = response.data.data.personData;
                return fetchedPerson;
            } else throw new Error("An error ocurred");
        } catch (error) {
            console.error("Error adding to activity:", error);
            return false;
        }
    };

    const updateCredential = async (personId, eventId) => {
        try {
            const response = await EventApi.createCredential({
                generated_at: formatDateToTimeZoneUTC(new Date()),
                is_valid_from: formatDateToTimeZoneUTC(new Date()),
                is_valid_until: formatDateToTimeZoneUTC(new Date()),
                enable: true,
                person_id: personId,
                event_id: eventId,
            });
            if (response?.data) return true;
        } catch (error) {
            console.error("Error updateCredential:", error);
            return false;
        }
    };

    const associateWithMaterial = async (personId, materialId) => {
        try {
            const response = await EventApi.associatePersonToMaterial(materialId, { person_id: personId });
            if (response?.data) return true;
        } catch (error) {
            console.error("Error associateWithMaterial:", error);
            return false;
        }
    };

    const desassociateFromMaterial = async (materialId) => {
        try {
            const response = await EventApi.desassociatePersonFromMaterial(materialId);
            if (response?.data) return true;
        } catch (error) {
            console.error("Error desassociateFromMaterial:", error);
            return false;
        }
    };

    const associateWithMultipleMaterials = async (materialsList) => {
        try {
            const response = await EventApi.associateWithMultipleMaterials({ materials: materialsList });
            console.log(response?.response);
            if (response?.data) return { data: response?.data, success: true };
            else if (response?.response) return { data: response?.response?.data, success: false };
            else throw new Error("Undefined Error");
        } catch (error) {
            console.error("Error associateWithMultipleMaterials:", error);
            return false;
        }
    };

    return {
        people,
        setPeople,
        person,
        setPerson,
        status,
        setStatus,
        fetchPersonById,
        registerAccess,
        registerAtActivity,
        updateCredential,
        associateWithMaterial,
        desassociateFromMaterial,
        associateWithMultipleMaterials,
    };
}

export default usePersonData;
